module.exports = __webpack_public_path__ + "img/flli-logo-large.1b4c5468.png";